module.exports = __webpack_public_path__ + "static/img/index-b_bg.9334ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/index-b_bg.png
// module id = nZvO
// module chunks = 1